/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {DeadwoodRipLayers, Layers} from "../view/DeadwoodRipLayers";
import {DeadwoodRip} from "../DeadwoodRip";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TimelineLite} from "gsap";
import {DeadwoodRipGameAssets} from "../DeadwoodRipGameAssets";

export class FreespinIntro extends ContinueScreen {

    private _text:PIXI.BitmapText;
    private _image:PIXI.Sprite;
    private _spine:PIXI.spine.Spine;

    constructor() {
        super(DeadwoodRipLayers.getLayer(Layers.SCREENS)!);

        this._image = new PIXI.Sprite();
        this._image.anchor.set(0.5);
        this._image.position.set(360, 360);

        this._text = new PIXI.BitmapText("", {
            fontName : DeadwoodRipGameAssets.BITMAP_FONT_INTRO_NUMBER,
            fontSize : 50,
            tint : 0xffffff
        });
        (<PIXI.Point>this._text.anchor).set(0.5, 1.38);
        this._text.letterSpacing = -40;
        this._text.position.set(360, 180);

        this._container.addChild(this._image);
        this._container.addChild(this._text);
    }

    public show(onContinueCallBack:() => void):TimelineLite {
        DeadwoodRip.xBetController.featureVisible = false;
        DeadwoodRip.shootingScreen.enabled = false;
        DeadwoodRip.multiplier.updateMultiplier(DeadwoodRip.model.data.multiplierFS, false);
        DeadwoodRip.background.updateMode(DeadwoodRip.model.data.nextMode);
        this._spine = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("introOutro"));
        this._spine.autoUpdate = true;

        // this._image.texture = DeadwoodRip.assetLoader.getTextures(`fsintro/${DeadwoodRip.model.data.nextMode === GameMode.FREESPIN_SUPER ? "SFS_intro" : "FS_intro"}`)[0];
        const fsLeft = DeadwoodRip.model.isRestore ? DeadwoodRip.model.parsedInitData.freespinsLeft : DeadwoodRip.model.parsedGameData.freespinsLeft;
        this._text.text = `${fsLeft}`;
        DeadwoodRipSound.fadeMusic(0, 100);
        DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.FREE_SPIN_INTRO_START});
        DeadwoodRipSound.playLoopEffect(DeadwoodRipSound.FREE_SPIN_INTRO);

        return super.show(onContinueCallBack);
    }

    protected getShowAnimations():TimelineLite {
        const aniName = DeadwoodRip.model.data.nextMode === GameMode.FREESPIN_SUPER ? "introSFS" : "introFS";
        const loopName = DeadwoodRip.model.data.nextMode === GameMode.FREESPIN_SUPER ? "introSFS_loop" : "introFS_loop";
        const tl = new TimelineLite();
        tl.add(() => {
            this._image.addChild(this._spine);
            this._spine.state.setAnimation(0, aniName, false);
        });
        tl.add(() => {
            this._spine.state.setAnimation(0, loopName, true);
        }, this._spine.spineData.findAnimation(aniName).duration);
        return tl;
    }

    protected close():TimelineLite {
        const soundName = DeadwoodRip.model.data.nextMode === GameMode.FREESPIN_SUPER ? DeadwoodRipSound.SUPER_FREE_SPIN_MUSIC : DeadwoodRipSound.FREE_SPIN_MUSIC;
        const tl = super.close();
        tl.add(() => {
            this._spine.state.setEmptyAnimations(0);
            this._image.removeChild(this._spine);
            this._spine.destroy();
            DeadwoodRip.background.updateMode(DeadwoodRip.model.data.nextMode);
            DeadwoodRipSound.stopLoopEffect(DeadwoodRipSound.FREE_SPIN_INTRO);
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.FREE_SPIN_START});
            DeadwoodRipSound.switchMusic(
                {name : soundName, volume : 0},
                {name : soundName, from : 0, to : 1, duration : 450},
            );
        }, 0);
        return tl;
    }
}